import { useState } from 'react';

import type { BottomDrawerSubscriptionState } from 'common/components/BottomDrawer/hooks';
import { EventBusEvent } from 'common/enums/EventBus';
import { useSubscriptionCallback } from 'common/hooks/subscription';
import { getInteger } from 'common/utils/number';

const DEFAULT_BOTTOM_MARGIN = ['sp_20', null, 'sp_24', 'sp_32'];

export const useBottomMargin = () => {
  const [bottomMargin, setBottomMargin] = useState(DEFAULT_BOTTOM_MARGIN);

  useSubscriptionCallback<BottomDrawerSubscriptionState>(
    EventBusEvent.BottomDrawerUpdate,
    ({ height }) => {
      setBottomMargin(DEFAULT_BOTTOM_MARGIN.map(value => `${getInteger(value ?? '0') + height}px`));
    }
  );

  return bottomMargin;
};
